import {Redirect} from "react-router-dom";
import React, {useEffect, useState} from "react";
import CssBaseline from "@material-ui/core/CssBaseline";
import MyAppBar from "./miscellaneous/MyAppBar";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Footer from "./miscellaneous/Footer";
import {useStyles, urlapi} from "./miscellaneous/constants";
import axios from "axios";

import TextField from "@material-ui/core/TextField";
import {Avatar, Checkbox, FormControlLabel} from "@material-ui/core";
import Typography from "@material-ui/core/Typography";
import Button from "@material-ui/core/Button";
import Grid from "@material-ui/core/Grid";
import Link from "@material-ui/core/Link";
import {useCookies} from "react-cookie";


export default function Login(props) {

    const classes = useStyles();
    const [cookies, setCookie, removeCookie] = useCookies(['analyzer']);

    async function signIn(e) {
        e.preventDefault()
        const email = e.target.elements['email'].value
        const password = e.target.elements['password'].value
        try {
            const response = (await axios.post(urlapi + "/token", {email:email, password:password}))
            const data = {id: response.data.id, name: response.data.name, token: response.data.token}
            //console.log(response.data)
            //console.log(data)
            setCookie("analyzer", data, "/");
        } catch (err) {
            alert("err : " + err);
        }
    }


    if(cookies && cookies.analyzer)
        return <Redirect to={"/"} />


    return (
        <div className={classes.root}>
            <CssBaseline/>
            <MyAppBar active={"home"}/>
            <main className={classes.content}>
                <br /><br /><br /><br /><br /><br />
                <div className={classes.appBarSpacer}/>
                <Container component="main" maxWidth="xs" style={{"minHeight": "90vh", "display": "flex", "flexDirection": "column"}}>
                    <CssBaseline />
                    <Box
                        sx={{
                            marginTop: 8,
                            display: 'flex',
                            flexDirection: 'column',
                            alignItems: 'center',
                        }}
                    >

                        <Typography component="h1" variant="h5">
                            Sign in
                        </Typography>
                        <Box component="form" onSubmit={e => signIn(e)} noValidate sx={{ mt: 1 }}>
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                id="email"
                                label="Email Address"
                                name="email"
                                autoComplete="email"
                                autoFocus
                            />
                            <TextField
                                margin="normal"
                                required
                                fullWidth
                                name="password"
                                label="Password"
                                type="password"
                                id="password"
                                autoComplete="current-password"
                            />
                            <FormControlLabel
                                control={<Checkbox value="remember" color="primary" />}
                                label="Remember me"
                            />
                            <Button
                                type="submit"
                                fullWidth
                                variant="contained"
                                sx={{ mt: 3, mb: 2 }}
                            >
                                Sign In
                            </Button>
                            <Grid container>
                                <Grid item xs>
                                    <Link href="#" variant="body2">
                                        Forgot password?
                                    </Link>
                                </Grid>
                                <Grid item>
                                    <Link href="#" variant="body2">
                                        {"Don't have an account? Sign Up"}
                                    </Link>
                                </Grid>
                            </Grid>
                        </Box>
                    </Box>
                </Container>
            </main>
        </div>
    )
}